// Form Data Actions

export const SET_FORM_DATA = 'SET_FORM_DATA';
export const SET_STEP='SET_STEP';
export const SET_MODEL_ID = 'SET_MODEL_ID';
export const UPDATE_ASSESSMENT_STEP='UPDATE_ASSESSMENT_STEP'
export const UPDATE_ASSESSMENT_STEP_SUCCESS='UPDATE_ASSESSMENT_STEP_SUCCESS'
export const UPDATE_ASSESSMENT_STEP_FAILURE='UPDATE_ASSESSMENT_STEP_FAILURE'
export const INITIALIZE_MODEL='INITIALIZE_MODEL'
export const FETCH_MODELS_FAILURE='FETCH_MODELS_FAILURE'
export const FETCH_MODELS_START='FETCH_MODELS_START'
export const FETCH_MODELS_SUCCESS='FETCH_MODELS_SUCCESS'
export const DELETE_MODEL = 'DELETE_MODEL';
export const UPDATE_CAUSE_FIELD = 'UPDATE_CAUSE_FIELD';

export const SET_RISK_SOURCE = 'SET_RISK_SOURCE';
export const SET_ROOT_CAUSE  = 'SET_ROOT_CAUSE';
export const SET_DEEP_DIVE_VALUES  = 'SET_DEEP_DIVE_VALUES';
export const SET_DEEP_DIVE_DETAIL  = 'SET_DEEP_DIVE_DETAIL';
export const SAVE_RISK_SOURCE_START = 'SAVE_RISK_SOURCE_START';
export const SAVE_RISK_SOURCE_SUCCESS = 'SAVE_RISK_SOURCE_SUCCESS';
export const SAVE_RISK_SOURCE_FAILURE = 'SAVE_RISK_SOURCE_FAILURE';

export const SAVE_CAUSES_START = 'SAVE_CAUSES_START';
export const SAVE_CAUSES_SUCCESS = 'SAVE_CAUSES_SUCCESS';
export const SAVE_CAUSES_FAILURE = 'SAVE_CAUSES_FAILURE';

// export const INITIALIZE_DRAFT_RISKS = 'INITIALIZE_DRAFT_RISKS'; // Legacy - removed

// Section Actions
export const SET_SECTION = 'SET_SECTION';
export const UPDATE_ACTIVE_SECTIONS_FROM_SAVED_RISKS = 'UPDATE_ACTIVE_SECTIONS_FROM_SAVED_RISKS';
export const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION';
export const SET_CURRENT_SECTION_STEP = 'SET_CURRENT_SECTION_STEP';
export const RESET_CURRENT_SECTION_STEP = 'RESET_CURRENT_SECTION_STEP';
export const SET_ASSESSMENT_POSITION = 'SET_ASSESSMENT_POSITION';
export const SKIP_SECTION = 'SKIP_SECTION';
export const TOGGLE_SECTION_NA = 'TOGGLE_SECTION_NA';
// New area-based actions
export const SET_AREA_STATUS = 'SET_AREA_STATUS';
export const SET_AREA_DEFERRED = 'SET_AREA_DEFERRED';
export const SET_AREA_NOT_APPLICABLE = 'SET_AREA_NOT_APPLICABLE';
export const CLEAR_AREA_STATUS = 'CLEAR_AREA_STATUS';

// Risk Actions
export const SET_RISKS = 'SET_RISKS';
export const TOGGLE_SELECTED_THEME = 'TOGGLE_SELECTED_THEME';
export const ADD_SELECTED_THEME = 'ADD_SELECTED_THEME';
export const REMOVE_SELECTED_THEME = 'REMOVE_SELECTED_THEME';
export const HANDLE_SELECTED_RISKS_UPDATE = 'HANDLE_SELECTED_RISKS_UPDATE';
export const SAVE_SELECTED_RISKS = 'SAVE_SELECTED_RISKS';
export const DISCARD_RISKS = 'DISCARD_RISKS';
export const UPDATE_RISKS_AFTER_SELECTION = 'UPDATE_RISKS_AFTER_SELECTION';
export const UPDATE_RISK_NAME='UPDATE_RISK_NAME';
export const SET_RISK_EVALUATION = 'SET_RISK_EVALUATION';
export const UPDATE_RISK_EVALUATION ='UPDATE_EVALUATION_DATA'
export const SET_RISK_PRIORITY='SET_RISK_PRIORITY'
export const UPDATE_RISK_PRIORITY='UPDATE_RISK_PRIORITY'
export const DISCARD_UNSAVED_RISKS='DISCARD_UNSELECTED_RISKS'
export const UPDATE_CONTROL_IN_SELECTED_RISK='UPDATE_CONTROL_IN_SELECTED_RISK'
export const FETCH_RISK_CARD_DATA_START = 'FETCH_RISK_CARD_DATA_START';
export const FETCH_RISK_CARD_DATA_SUCCESS = 'FETCH_RISK_CARD_DATA_SUCCESS';
export const FETCH_RISK_CARD_DATA_FAILURE = 'FETCH_RISK_CARD_DATA_FAILURE';
export const MOVE_RISK_TO_SAVED = 'MOVE_RISK_TO_SAVED';
export const UPDATE_SAVED_RISK = 'UPDATE_SAVED_RISK';
export const DISCARD_SAVED_RISK='DISCARD_SAVED_RISK';
export const REFRESH_RISKS_SUCCESS = 'REFRESH_RISKS_SUCCESS';
export const FETCH_MODEL_RISKS_START='FETCH_MODEL_RISKS_START'
export const FETCH_MODEL_RISKS_SUCCESS='FETCH_MODEL_RISKS_SUCCESS'
export const FETCH_MODEL_RISKS_FAILURE='FETCH_MODEL_RISKS_FAILURE'
export const SET_RISK_PRIORITY_START='SET_RISK_PRIORITY_START'
export const SET_RISK_PRIORITY_SUCCESS='SET_RISK_PRIORITY_SUCCESS'
export const SET_RISK_PRIORITY_FAILURE='SET_RISK_PRIORITY_FAILURE'
export const GENERATE_RISKS_WITH_RAG ='GENERATE_RISKS_WITH_RAG'
export const REFINE_RISK_START='REFINE_RISK_START'
export const REFINE_RISK_SUCCESS='REFINE_RISK_SUCCESS'
export const REFINE_RISK_FAILURE='REFINE_RISK_FAILURE'
export const ADD_MANUAL_RISK='ADD_MANUAL_RISK'
export const SET_FIELD      = 'SET_FIELD';
// Single-risk flow (new)
export const SELECT_RISK_SOURCE   = 'SELECT_RISK_SOURCE';
export const DESELECT_RISK_SOURCE = 'DESELECT_RISK_SOURCE';
export const FETCH_RISK_SCENARIOS_START   = 'FETCH_RISK_SCENARIOS_START';
export const FETCH_RISK_SCENARIOS_SUCCESS = 'FETCH_RISK_SCENARIOS_SUCCESS';
export const FETCH_RISK_SCENARIOS_FAILURE = 'FETCH_RISK_SCENARIOS_FAILURE';
export const REFINE_SCENARIO_START        = 'REFINE_SCENARIO_START';
export const REFINE_SCENARIO_FAILURE      = 'REFINE_SCENARIO_FAILURE';
export const REFINE_SCENARIO_SUCCESS      = 'REFINE_SCENARIO_SUCCESS';
export const MOVE_SCENARIO_TO_RISKS       = 'MOVE_SCENARIO_TO_RISKS';
export const CLEAR_SCENARIOS              = 'CLEAR_SCENARIOS';
export const REGISTER_RISK_SOURCES     = 'REGISTER_RISK_SOURCES';
export const TOGGLE_RISK_SOURCE       = 'TOGGLE_RISK_SOURCE';
export const SET_RISK_SOURCE_PROGRESS = 'SET_RISK_SOURCE_PROGRESS';
// risk narrative
export const GENERATE_RISK_NARRATIVE_START   = 'GENERATE_RISK_NARRATIVE_START';
export const GENERATE_RISK_NARRATIVE_SUCCESS = 'GENERATE_RISK_NARRATIVE_SUCCESS';
export const GENERATE_RISK_NARRATIVE_FAILURE = 'GENERATE_RISK_NARRATIVE_FAILURE';

//UTILITY FUNCTIONS
export const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP';
export const UPDATE_ASSESSMENT_STATUS = 'UPDATE_ASSESSMENT_STATUS';
export const ASSESSMENT_STATUS_UPDATED = 'ASSESSMENT_STATUS_UPDATED';
export const ASSESSMENT_STATUS_FAILED = 'ASSESSMENT_STATUS_FAILED';
export const UPDATE_LOADING_MESSAGE='UPDATE_LOADING_MESSAGE'
export const UPDATE_SECTION_PROGRESS = 'UPDATE_SECTION_PROGRESS';

// Fetch Actions
export const FETCH_RISKS_START = 'FETCH_RISKS_START';
export const FETCH_RISKS_SUCCESS = 'FETCH_RISKS_SUCCESS';
export const FETCH_RISKS_FAILURE = 'FETCH_RISKS_FAILURE';
export const FETCH_RISKS_FROM_LLM = 'FETCH_RISKS_FROM_LLM';
export const FETCH_SECTION_SPECIFIC_RISKS_START='FETCH_SECTION_SPECIFIC_RISKS_START';
export const FETCH_SECTION_SPECIFIC_RISKS_SUCCESS='FETCH_SECTION_SPECIFIC_RISKS_SUCCESS';
export const FETCH_SECTION_SPECIFIC_RISKS_FAILURE = 'FETCH_SECTION_SPECIFIC_RISKS_FAILURE';
export const FETCH_RISK_EVALUATIONS='FETCH_RISK_EVALUATIONS'
export const FETCH_RISK_EVALUATIONS_SUCCESS='FETCH_RISK_EVALUATIONS_SUCCESS'
export const FETCH_RISK_EVALUATIONS_FAILURE='FETCH_RISK_EVALUATIONS_FAILURE'


export const RESET_RISKS_STATE = 'RESET_RISKS_STATE'
//Security Actions
export const LOAD_SECURITY_ASSESSMENT = 'LOAD_SECURITY_ASSESSMENT'
export const UPDATE_SECURITY_ASSESSMENT = 'UPDATE_SECURITY_ASSESSMENT';
export const SAVE_SECURITY_ASSESSMENT = 'SAVE_SECURITY_ASSESSMENT';
export const SAVE_SECURITY_ASSESSMENT_SUCCESS = 'SAVE_SECURITY_ASSESSMENT_SUCCESS';
export const SAVE_SECURITY_ASSESSMENT_FAILURE = 'SAVE_SECURITY_ASSESSMENT_FAILURE';
// Scenario-scoped security assessment
export const UPDATE_SCENARIO_ASSESSMENT = 'UPDATE_SCENARIO_ASSESSMENT';
export const LOAD_SCENARIOS_SUCCESS = 'LOAD_SCENARIOS_SUCCESS';
export const SAVE_SCENARIO_SUCCESS = 'SAVE_SCENARIO_SUCCESS';
export const SAVE_SCENARIO_FAILURE = 'SAVE_SCENARIO_FAILURE';
export const DELETE_SCENARIO_SUCCESS = 'DELETE_SCENARIO_SUCCESS';
export const DELETE_SCENARIO_FAILURE = 'DELETE_SCENARIO_FAILURE';
export const GENERATE_SECURITY_RISKS_START = 'GENERATE_SECURITY_RISKS_START';
export const GENERATE_SECURITY_RISKS_SUCCESS = 'GENERATE_SECURITY_RISKS_SUCCESS';
export const GENERATE_SECURITY_RISKS_FAILURE = 'GENERATE_SECURITY_RISKS_FAILURE';
export const SET_ACTIVE_IDS = 'SET_ACTIVE_IDS';
export const FETCH_SECURITY_ASSESSMENT_START = 'FETCH_SECURITY_ASSESSMENT_START';
export const FETCH_SECURITY_ASSESSMENT_SUCCESS = 'FETCH_SECURITY_ASSESSMENT_SUCCESS';
export const FETCH_SECURITY_ASSESSMENT_FAILURE = 'FETCH_SECURITY_ASSESSMENT_FAILURE';
export const RESET_SECURITY_STATE = 'RESET_SECURITY_STATE'
export const SAVE_SECURITY_RISK_START = 'SAVE_RISK_START';
export const SAVE_SECURITY_RISK_SUCCESS = 'SAVE_RISK_SUCCESS';
export const SAVE_SECURITY_RISK_FAILURE = 'SAVE_RISK_FAILURE';
export const FETCH_SECURITY_RISKS_START = 'FETCH_SECURITY_RISKS_START';
export const FETCH_SECURITY_RISKS_SUCCESS = 'FETCH_SECURITY_RISKS_SUCCESS';
export const FETCH_SECURITY_RISKS_FAILURE = 'FETCH_SECURITY_RISKS_FAILURE';
export const DISCARD_SECURITY_RISK_START = 'DISCARD_SECURITY_RISK_START';
export const DISCARD_SECURITY_RISK_SUCCESS = 'DISCARD_SECURITY_RISK_SUCCESS';
export const DISCARD_SECURITY_RISK_FAILURE = 'DISCARD_SECURITY_RISK_FAILURE';
export const FETCH_SECURITY_CONTROLS_START = 'FETCH_SECURITY_CONTROLS_START';
export const FETCH_SECURITY_CONTROLS_SUCCESS = 'FETCH_SECURITY_CONTROLS_SUCCESS';
export const FETCH_SECURITY_CONTROLS_FAILURE = 'FETCH_SECURITY_CONTROLS_FAILURE';
export const SAVE_SECURITY_CONTROL_START = 'SAVE_SECURITY_CONTROL_START';
export const SAVE_SECURITY_CONTROL_SUCCESS = 'SAVE_SECURITY_CONTROL_SUCCESS';
export const SAVE_SECURITY_CONTROL_FAILURE = 'SAVE_SECURITY_CONTROL_FAILURE';



//Context Actions

export const SET_CONTEXT_DATA = 'SET_CONTEXT_DATA';
export const UPDATE_CONTEXT_DATA = 'UPDATE_CONTEXT_DATA';
export const SAVE_CONTEXT_DATA_START='SAVE_CONTEXT_DATA_START'
export const SAVE_CONTEXT_DATA_SUCCESS = 'SAVE_CONTEXT_DATA_SUCCESS';
export const SAVE_CONTEXT_DATA_FAILURE = 'SAVE_CONTEXT_DATA_FAILURE';
export const FETCH_NARRATIVE_START = 'FETCH_NARRATIVE_START';
export const FETCH_NARRATIVE_SUCCESS = 'FETCH_NARRATIVE_SUCCESS';
export const FETCH_NARRATIVE_FAILURE = 'FETCH_NARRATIVE_FAILURE';
export const FETCH_UNIFIED_NARRATIVE_SUCCESS = 'FETCH_UNIFIED_NARRATIVE_SUCCESS';
export const FETCH_CONTEXT_DATA_START = 'FETCH_CONTEXT_DATA_START';
export const FETCH_CONTEXT_DATA_SUCCESS = 'FETCH_CONTEXT_DATA_SUCCESS';
export const FETCH_CONTEXT_DATA_FAILURE = 'FETCH_CONTEXT_DATA_FAILURE';
export const GENERATE_SECURITY_CONTROLS_START='GENERATE_SECURITY_CONTROLS_START'
export const GENERATE_SECURITY_CONTROLS_SUCCESS='GENERATE_SECURITY_CONTROLS_SUCCESS'
export const GENERATE_SECURITY_CONTROLS_FAILURE='GENERATE_SECURITY_CONTROLS_FAILURE'

//COnfig Actions
export const RESET_CONFIG_STATE='RESET_CONFIG_STATE'

export const CONFIG_UPDATE_SUCCESS = 'CONFIG_UPDATE_SUCCESS';
export const CONFIG_UPDATE_FAILURE = 'CONFIG_UPDATE_FAILURE';

export const FETCH_CONFIG_START = 'FETCH_CONFIG_START';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_FAILURE = 'FETCH_CONFIG_FAILURE';

export const FETCH_ALL_CONFIGS_START = 'FETCH_ALL_CONFIGS_START';
export const FETCH_ALL_CONFIGS_SUCCESS = 'FETCH_ALL_CONFIGS_SUCCESS';
export const FETCH_ALL_CONFIGS_FAILURE = 'FETCH_ALL_CONFIGS_FAILURE';

export const SAVE_CONFIG_START = 'SAVE_CONFIG_START';
export const SAVE_CONFIG_SUCCESS = 'SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_FAILURE = 'SAVE_CONFIG_FAILURE';

//residual Risk
export const GENERATE_RESIDUAL_RISK_START = 'GENERATE_RESIDUAL_RISK_START';
export const GENERATE_RESIDUAL_RISK_SUCCESS = 'GENERATE_RESIDUAL_RISK_SUCCESS';
export const GENERATE_RESIDUAL_RISK_FAILURE = 'GENERATE_RESIDUAL_RISK_FAILURE';
export const UPDATE_RESIDUAL_RISK = 'OVERRIDE_RESIDUAL_RISK';
export const ANALYZE_ACTIONPLAN_START = 'ANALYZE_ACTIONPLAN_START';
export const ANALYZE_ACTIONPLAN_SUCCESS = 'ANALYZE_ACTIONPLAN_SUCCESS';
export const ANALYZE_ACTIONPLAN_FAILURE = 'ANALYZE_ACTIONPLAN_FAILURE';
export const SAVE_RESIDUAL_RISK_START = 'SAVE_RESIDUAL_RISK_START';
export const SAVE_RESIDUAL_RISK_SUCCESS = 'SAVE_RESIDUAL_RISK_SUCCESS';
export const SAVE_RESIDUAL_RISK_FAILURE = 'SAVE_RESIDUAL_RISK_FAILURE';
export const FETCH_RESIDUAL_RISK_START = 'FETCH_RESIDUAL_RISK_START';
export const FETCH_RESIDUAL_RISK_SUCCESS = 'FETCH_RESIDUAL_RISK_SUCCESS';
export const FETCH_RESIDUAL_RISK_FAILURE = 'FETCH_RESIDUAL_RISK_FAILURE';

//monitors actions

export const RUN_STAGE_MONITOR_REQUEST  = 'RUN_STAGE_MONITOR_REQUEST';
export const RUN_STAGE_MONITOR_SUCCESS  = 'RUN_STAGE_MONITOR_SUCCESS';
export const RUN_STAGE_MONITOR_FAILURE  = 'RUN_STAGE_MONITOR_FAILURE';
export const CLEAR_MONITOR_DATA = 'CLEAR_MONITOR_DATA';
// Risk‑Card monitor
export const RUN_RISKCARD_MONITOR_REQUEST = 'RUN_RISKCARD_MONITOR_REQUEST';
export const RUN_RISKCARD_MONITOR_SUCCESS = 'RUN_RISKCARD_MONITOR_SUCCESS';
export const RUN_RISKCARD_MONITOR_FAILURE = 'RUN_RISKCARD_MONITOR_FAILURE';
export const CLEAR_RISKCARD_MONITOR      = 'CLEAR_RISKCARD_MONITOR';

export const RUN_SCENARIO_MONITOR_REQUEST  = 'RUN_SCENARIO_MONITOR_REQUEST';
export const RUN_SCENARIO_MONITOR_SUCCESS  = 'RUN_SCENARIO_MONITOR_SUCCESS';
export const RUN_SCENARIO_MONITOR_FAILURE  = 'RUN_SCENARIO_MONITOR_FAILURE';
export const CLEAR_SCENARIO_MONITOR         = 'CLEAR_SCENARIO_MONITOR';

//Action Plan
export const AP_FETCH_START          = 'AP_FETCH_START';
export const AP_FETCH_SUCCESS        = 'AP_FETCH_SUCCESS';
export const AP_FETCH_ERROR          = 'AP_FETCH_ERROR';

export const AP_ADD_CONTROL          = 'AP_ADD_CONTROL';      // save or restore
export const AP_EDIT_CONTROL         = 'AP_EDIT_CONTROL';     // inline rename
export const AP_DISCARD_CONTROL      = 'AP_DISCARD_CONTROL';  // trash icon
export const AP_UPDATE_STATUS        = 'AP_UPDATE_STATUS';    // change “generated” → “saved”
export const AP_RESET_MODEL          = 'AP_RESET_MODEL';      // clear on logout / model-switch